// extracted by mini-css-extract-plugin
export default {"top":"index_top_aqjZO"};